'use strict';

/**
 * @ngdoc function
 * @name myConsultApp.controller:createProPet
 * @description
 * # createProPet
 * Controller of the myConsultApp
 */
angular
  .module('myConsultApp')
  .controller(
    'createProPet',
    function (
      $scope,
      $rootScope,
      $route,
      $routeParams,
      $location,
      $timeout,
      crumble,
      PetsService,
      IdentityService,
      ProvidersService,
      $filter,
    ) {
      if ($scope.isAdminUser || $scope.isSuperUser) {
        $location.path('/admin');
      }
      $scope.crumble = crumble;
      crumble.update();
      $scope.todaysDate = new Date();
      $scope.currentPet = {
        pet: {
          species: null,
          is_active: true,
          is_male: null,
          petprofile: {},
          date_of_birth: $scope.todaysDate,
          organization_association: [],
        },
      };

      $scope.currentPetOwnerFullName = '';
      $scope.sheltarModalTitle = 'Choose Shelter';
      $scope.veterinarianModalTitle = 'Choose Veterinarian';
      $scope.breedList = null;
      $scope.path = null;
      $scope.petDobValid = true;
      $scope.sheltarData = null;
      $scope.lastBreedValue = null;
      $scope.currentBreedTitle = null;
      $scope.currentPetBreedId = null;
      $scope.wizardData = {};
      $scope.preselected = null;

      $scope.isFromSubmitInvoice = $location.search().submitInvoice ?? false;

      var providerData = {
        petProvider: {
          organization: $scope.selectedSheltar,
          relation_type: 'shelter',
        },
      };
      $scope.ownerInfo = {
        client_info: {},
      };
      $scope.searchClients = function (query) {
        $scope.callback = function () {
          return;
        };
        return IdentityService.getClientInfo(query).then(function (res) {
          return res;
        });
      };

      $scope.searchClientsPage = function (query) {
        return IdentityService.getClientInfoPage(query).then(function (res) {
          return res;
        });
      };
      $scope.dataSet = function () {
        window.onbeforeunload = function () {
          return true;
        };
      };

      if (IdentityService.getStoredUser() != '') {
        var thisUser = IdentityService.getStoredUser();
        $scope.preselected = {};
        $scope.preselected.title = thisUser.first_name + ' ' + thisUser.last_name;
        $scope.preselected.originalObject = thisUser;
        $scope.wizardData.client_info = thisUser;
        window.scrollTo(0, 0);
      }

      $scope.verifyPetOwner = function (data) {
        $scope.dataSet();
        $scope.loading = true;
        if (
          !$scope.wizardData.client_info ||
          ($scope.wizardData.client_info && data.id != $scope.wizardData.client_info.id)
        ) {
          $scope.wizardData.client_info = data;
        }
      };

      $scope.updateGender = function (gender) {
        $scope.currentPet.pet.is_male = gender;
      };

      $scope.setProvider = function (obj) {
        if ($scope.currentPet.pet.organization_association == undefined) {
          $scope.currentPet.pet.organization_association = [];
        }
        var index = $scope.currentPet.pet.organization_association.indexOf(obj);
        if (index > -1) {
          $scope.currentPet.pet.organization_association.splice(index, 1);
          var newIndex = $scope.providers
            .map(function (i) {
              return i.value;
            })
            .indexOf(obj);
          $scope.providers[newIndex].isSelected = false;
        } else {
          $scope.currentPet.pet.organization_association.push(obj);
          var newIndex = $scope.providers
            .map(function (i) {
              return i.value;
            })
            .indexOf(obj);
          $scope.providers.isSelected = true;
        }
      };

      $scope.genders = [
        { name: 'Male', value: true },
        { name: 'Female', value: false },
      ];
      $scope.species = [
        { name: 'Dog', value: 1 },
        { name: 'Cat', value: 2 },
      ];
      $scope.providers = [
        { name: 'Clinic', value: 'primary', isSelected: false },
        { name: 'Shelter', value: 'shelter', isSelected: false },
      ];

      $scope.error = {
        status: false,
        details: '',
        highlightedFields: { breed: [] },
      };

      $scope.submit = {
        success: false,
      };

      $scope.reloadRoute = function () {
        $scope.submit.success = false;
        $route.reload();
      };
      $scope.petDetails = {
        ownerId: null,
        petId: null,
      };

      $scope.isProviderType = function (provider) {
        if (provider == 'primary') {
          provider = 'clinic';
        }
        var newIndex = $scope.currentOrganization.directory_type
          .map(function (i) {
            return i.slug;
          })
          .indexOf(provider);
        if (newIndex > -1) {
          return true;
        } else {
          return false;
        }
      };

      $scope.createPet = function () {
        $scope.error.status = false;
        if ($scope.currentPet.pet.organization_association == undefined) {
          $scope.currentPet.pet.organization_association = [];
        }
        var formatedDate = $filter('date')($scope.currentPet.pet.date_of_birth, 'yyyy-MM-dd');
        var filterBreed = [];
        if ($scope.currentPet.pet.organization_association < 1) {
          if ($scope.currentOrganization.directory_type[0] != undefined) {
            if ($scope.currentOrganization.directory_type[0].slug == 'clinic') {
              $scope.currentPet.pet.organization_association.push('primary');
            } else {
              $scope.currentPet.pet.organization_association.push(
                $scope.currentOrganization.directory_type[0].slug,
              );
            }
          } else {
            $scope.currentPet.pet.organization_association.push('primary');
          }
        }
        if (!$scope.isAdminUser) {
          var pet = {
            pet: {
              name: $scope.currentPet.pet.name,
              breed: null,
              is_male: Boolean($scope.currentPet.pet.is_male),
              user_id: $scope.wizardData.client_info.id,
              species: Number($scope.currentPet.pet.species),
              is_active: true,
              date_of_birth: formatedDate,
              organization_association: $scope.currentPet.pet.organization_association.toString(),
              provider_id: $scope.currentOrganization.id,
              petprofile: {},
            },
          };
        } else {
          var pet = {
            pet: {
              name: $scope.currentPet.pet.name,
              breed: null,
              is_male: Boolean($scope.currentPet.pet.is_male),
              user_id: $scope.wizardData.client_info.id,
              species: Number($scope.currentPet.pet.species),
              is_active: true,
              date_of_birth: formatedDate,
              petprofile: {},
            },
          };
        }

        if ($scope.lastBreedValue.originalObject == undefined) {
          $scope.error.status = true;
          $scope.error.details = 'Please fix the highlighted field(s).';
          $scope.error.highlightedFields.breed = ['Invalid breed'];
          return;
        } else {
          pet.pet.breed = $scope.lastBreedValue.originalObject.id;
        }

        PetsService.createdProPet(pet).then(
          function (result) {
            $scope.petDetails.ownerId = $scope.wizardData.client_info.id;
            $scope.petDetails.petId = result.pet.id;
            if ($scope.path) {
              IdentityService.setRecentCreatedPetId(result.pet.id);
            }
            if ($scope.isFromSubmitInvoice) {
              $location.url('/rewards/receipt-upload');
            }
            $scope.submit.success = true;
          },
          function (error) {
            if (error.status == 500) {
              $scope.error.details =
                'There was an error with your request. Please try again in a few minutes.';
            } else if (error.status == 400) {
              $scope.error.details = 'Please fix the highlighted field(s).';
              $scope.error.highlightedFields = error.data.pet;
              if (error.data.pet.non_field_errors) {
                $scope.error.details = error.data.pet.non_field_errors[0];
              }
            } else {
              $scope.error.details = error.statusText;
            }
            $scope.error.status = true;
          },
        );
      };

      $scope.selectBreed = function ($item) {
        if ($item !== undefined) {
          $scope.lastBreedValue = $item;
        } else {
          $scope.lastBreedValue = undefined;
        }
      };

      $scope.setBreedList = function () {
        var auxBreedList = [];
        angular.forEach($scope.originalBreedList, function (value, key) {
          if (value.species == $scope.currentPet.pet.species) {
            auxBreedList.push(value);
          }
        });
        $scope.breedList = auxBreedList;
        $scope.currentPet.pet.breed = null;
        $scope.currentBreedTitle = '';
        $scope.lastBreedValue = null;
        $scope.currentPetBreedId = null;
        $('#petBreedList_value').val('');
      };

      $scope.checkBreedValue = function () {
        //there seems to be a bug with the autocomplete directive. Only way to make this work:
        $timeout(function () {
          if ($scope.lastBreedValue) {
            $scope.currentBreedTitle = $scope.lastBreedValue.title;
            $('#petBreedList_value').val($scope.currentBreedTitle);
          }
        }, 300);
      };

      $scope.$watch(
        'currentPet.pet.date_of_birth',
        function (newVal, oldVal) {
          if (newVal !== oldVal)
            $scope.petDobValid = $scope.currentPet.pet.date_of_birth <= $scope.todaysDate;
        },
        true,
      );

      $scope.$on('sheltarChanged', function (event, changedValue) {
        $scope.selectedSheltar = changedValue.data;
        $scope.sheltarData = ProvidersService.getSheltar();
        providerData.petProvider.organization = $scope.sheltarData.id;
        providerData.petProvider.relation_type = 'shelter';
      });

      $scope.$on('selectedVeterinarian', function (event, changedValue) {
        $scope.selectedVaterinarian = changedValue.data;
        $scope.vetData = ProvidersService.getVeterinarian();
        providerData.petProvider.organization = $scope.vetData.id;
        providerData.petProvider.relation_type = 'primary';
      });

      $scope.$on('$viewContentLoaded', function () {
        PetsService.getBreeds().then(function (response) {
          $scope.originalBreedList = response.breeds;
        });

        $scope.generatingCrumble = function () {
          return true;
        };

        if (IdentityService.getSelectedUsersPath() != null) {
          $scope.path = IdentityService.getSelectedUsersPath();
        }
      });
    },
  );
